import type { BanksData } from '@/shared/types';
import type { PaidInvoice } from '../api';

const findBankNameByKey = (
  bankKey: string,
  banksData: BanksData | undefined
): string | undefined => {
  const countries = banksData?.deposit?.countries;

  if (!countries) return undefined;

  for (const country of countries) {
    const bank = country.banks?.find(item => item.bankKey === bankKey);
    if (bank) return bank.bankName;
  }

  return undefined;
};

const getPaidInvoiceBankName = (
  invoice: PaidInvoice,
  banksData: BanksData | undefined,
  fallback: string
): string => {
  return (
    invoice.bankName ||
    findBankNameByKey(invoice.bankKey, banksData) ||
    fallback
  );
};

export { getPaidInvoiceBankName };
